var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": false,
              "show-new": _vm.canManage,
              "show-print": false,
              "show-delete": false,
              "show-save": false,
              "show-cancel": false,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "tile is-ancestor is-parent" }, [
            _vm.activeDevices.length === 0 && !_vm.isLoading
              ? _c("div", { staticClass: "tile is-parent" }, [_vm._m(0)])
              : _c("div", { staticClass: "tile is-parent" }, [
                  _c(
                    "div",
                    { staticClass: "columns is-multiline" },
                    _vm._l(_vm.activeDevices, function (device, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "column is-narrow" },
                        [
                          device
                            ? _c("div", { staticClass: "card" }, [
                                _c("header", { staticClass: "card-header" }, [
                                  _c(
                                    "p",
                                    { staticClass: "card-header-title" },
                                    [
                                      !device.isEdit
                                        ? _c(
                                            "span",
                                            { staticClass: "is-uppercase" },
                                            [_vm._v(_vm._s(device.deviceName))]
                                          )
                                        : _c(
                                            "span",
                                            { staticStyle: { width: "100%" } },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: device.deviceName,
                                                    expression:
                                                      "device.deviceName",
                                                  },
                                                ],
                                                staticClass:
                                                  "input is-uppercase",
                                                class: {
                                                  "is-static": !device.isEdit,
                                                  "is-danger":
                                                    _vm.$v.devices.$each[index]
                                                      .deviceName.$error,
                                                },
                                                attrs: {
                                                  readonly: !device.isEdit,
                                                  placeholder: "Device Name",
                                                },
                                                domProps: {
                                                  value: device.deviceName,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      device,
                                                      "deviceName",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm.$v.devices.$each[index]
                                                .deviceName.$dirty &&
                                              !_vm.$v.devices.$each[index]
                                                .deviceName.required
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "help is-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Device Name is required."
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                    ]
                                  ),
                                  _vm.canManage
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "buttons",
                                          staticStyle: {
                                            "margin-right": "5px",
                                            "margin-top": "-5px",
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "has-text-primary is-outlined",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleEdit(
                                                    index,
                                                    device
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "icon" },
                                                [
                                                  _c("i", {
                                                    staticClass: "mdi mdi-24px",
                                                    class: [
                                                      device.isEdit
                                                        ? "mdi-content-save"
                                                        : "mdi-lead-pencil",
                                                    ],
                                                    attrs: {
                                                      "aria-hidden": "true",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "has-text-danger is-outlined",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteDevice(
                                                    index,
                                                    device
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._m(1, true)]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _c("div", { staticClass: "card-content" }, [
                                  _c("div", { staticClass: "content" }, [
                                    _c("div", { staticClass: "field" }, [
                                      _c(
                                        "label",
                                        { staticClass: "label is-small" },
                                        [_vm._v("Device ID")]
                                      ),
                                      _c("div", { staticClass: "control" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: device.deviceId,
                                              expression: "device.deviceId",
                                            },
                                          ],
                                          staticClass:
                                            "input is-small deviceid-input-small is-uppercase",
                                          class: {
                                            "is-static": !device.isEdit,
                                            "is-danger":
                                              _vm.$v.devices.$each[index]
                                                .deviceId.$error,
                                          },
                                          attrs: {
                                            readonly: !device.isEdit,
                                            placeholder: "Device ID",
                                          },
                                          domProps: { value: device.deviceId },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                device,
                                                "deviceId",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm.$v.devices.$each[index].deviceId
                                          .$dirty &&
                                        !_vm.$v.devices.$each[index].deviceId
                                          .required
                                          ? _c(
                                              "span",
                                              { staticClass: "help is-danger" },
                                              [_vm._v("Device ID is required.")]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]),
                                    _c("div", { staticClass: "field" }, [
                                      _c("div", { staticClass: "field-body" }, [
                                        _c("div", { staticClass: "field" }, [
                                          _c(
                                            "label",
                                            { staticClass: "label is-small" },
                                            [_vm._v("Device Information")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "control" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      device.deviceInformation,
                                                    expression:
                                                      "device.deviceInformation",
                                                  },
                                                ],
                                                staticClass: "input is-small",
                                                class: {
                                                  "is-static": !device.isEdit,
                                                  "is-danger":
                                                    _vm.$v.devices.$each[index]
                                                      .deviceInformation.$error,
                                                },
                                                attrs: {
                                                  readonly: !device.isEdit,
                                                  placeholder: "Device ID",
                                                },
                                                domProps: {
                                                  value:
                                                    device.deviceInformation,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      device,
                                                      "deviceInformation",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm.$v.devices.$each[index]
                                                .deviceInformation.$dirty &&
                                              !_vm.$v.devices.$each[index]
                                                .deviceInformation.required
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "help is-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Device Information is required."
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]),
                                        !device.isEdit
                                          ? _c(
                                              "div",
                                              { staticClass: "field" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "label is-small",
                                                  },
                                                  [_vm._v("Registered Date")]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "control" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "is-size-7",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$filters.formatDateLocale(
                                                              device.registeredDate,
                                                              _vm.$userInfo
                                                                .locale
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "field" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "label is-small",
                                                  },
                                                  [_vm._v("Registered Date")]
                                                ),
                                                _c("v-date-picker", {
                                                  attrs: {
                                                    "is-dark":
                                                      _vm.$theme.isDark,
                                                    masks: _vm.formats,
                                                    attributes: _vm.attrs,
                                                    locale:
                                                      _vm.$userInfo.locale,
                                                    disabled: !device.isEdit,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          inputValue,
                                                          inputEvents,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "field",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "control has-icons-left",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "input",
                                                                      _vm._g(
                                                                        {
                                                                          staticClass:
                                                                            "input is-small",
                                                                          attrs:
                                                                            {
                                                                              type: "text",
                                                                              placeholder:
                                                                                "Registered Date",
                                                                            },
                                                                          domProps:
                                                                            {
                                                                              value:
                                                                                inputValue,
                                                                            },
                                                                        },
                                                                        inputEvents
                                                                      )
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "icon is-small is-left",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "mdi mdi-calendar mdi-18px",
                                                                          }
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: device.selectedDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        device,
                                                        "selectedDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "device.selectedDate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
          ]),
          _vm.device
            ? _c(
                "confirm-modal",
                {
                  attrs: {
                    active: _vm.isConfirmModalActive,
                    "ok-text": "Yes",
                    "cancel-text": "No",
                  },
                  on: {
                    "update:active": function ($event) {
                      _vm.isConfirmModalActive = $event
                    },
                    ok: function ($event) {
                      return _vm.deleteEntity(true)
                    },
                    cancel: function ($event) {
                      return _vm.deleteEntity(false)
                    },
                  },
                },
                [
                  _c(
                    "p",
                    { attrs: { slot: "text-title" }, slot: "text-title" },
                    [_vm._v("Delete Device Registration")]
                  ),
                  _c(
                    "p",
                    { attrs: { slot: "text-content" }, slot: "text-content" },
                    [
                      _vm._v(" Device "),
                      _c(
                        "span",
                        {
                          staticClass: "has-text-primary has-text-weight-bold",
                        },
                        [_vm._v(_vm._s(`${_vm.device.deviceName}`))]
                      ),
                      _vm._v(" will be de-registered. Continue? "),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tile is-vertical is-12" }, [
      _c("div", { staticClass: "box" }, [
        _c("section", { staticClass: "section" }, [
          _c(
            "div",
            { staticClass: "content has-text-grey has-text-centered" },
            [
              _c("span", { attrs: { icon: "icon is-large" } }, [
                _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
              ]),
              _c("p", [_vm._v("No devices registered")]),
            ]
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", {
        staticClass: "mdi mdi-delete mdi-24px",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }